import React from "react";
import styled from "styled-components";
import baseStyles from "../../styles/baseStyles";

const IconSVG = styled.svg`
  width: ${props => props.size}rem;
  height: ${props => props.size}rem;
  fill: ${props => props.color || baseStyles.color.lightGray};
`;

const Icon = ({ iconRef, size, color, ...props }) => (
  <IconSVG size={size} color={color} {...props}>
    <use xlinkHref={`#${iconRef.id}`} />
  </IconSVG>
);

export default Icon;



// WEBPACK FOOTER //
// ./src/components/UI/Icon.js